// Core
import {
	Box,
	Button,
	Flex,
	Grid,
	Image,
	Text,
	useColorModeValue
} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import placeholder from 'assets/img/placeholder-partner.jpg';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { LockedIcon } from 'components/Icons/Icons';

// Components
import Card from 'components/Card/Card';

const previewItems = [
	{ name: 'Partner name', discount: 'Up to 20% off', categories: 'Automotive' },
	{ name: 'Partner name', discount: 'Up to 15% off', categories: 'Food & Beverages' },
	{ name: 'Partner name', discount: 'Up to 10% off', categories: 'Health & Fitness' },
	{ name: 'Partner name', discount: 'Up to 25% off', categories: 'Retail' }
];

const LockedPartners = () => {
	const blurColor = useColorModeValue('rgba(255, 255, 255, 0.30)', 'rgba(0, 0, 0, 0.30)');
	const textColor = useColorModeValue('#262D47', '#9FABCB');

	return (
		<Box position="relative">
			<Grid
				templateColumns={{ sm: '1fr', md: '1fr 1fr', lg: '1fr 1fr' }}
				gap="24px"
				templateRows="1fr"
				filter="blur(2px)"
				userSelect="none"
				pointerEvents="none"
				aria-hidden="true">
				{previewItems.map((item, index) => (
					<Card key={index} overflow="hidden" padding="0" position="relative">
						<Image src={placeholder} alt="partner" objectFit="cover" maxH="147px" h="100%" />
						<Box p="12px 12px 16px 12px">
							<Text variant="header" fontSize="16px" mb="12px" letterSpacing="0px">{item.name}</Text>
							<Text variant="title-lg" fontSize="22px" fontWeight="700" mb="2px" mt="24px">{item.discount}</Text>
							<Text variant="text-sm" fontWeight="500" color={textColor}>{item.categories}</Text>
						</Box>
					</Card>
				))}
			</Grid>

			<Flex
				position="absolute"
				top="0"
				left="0"
				w="100%"
				h="100%"
				zIndex="9"
				bg={blurColor}
				backdropFilter="blur(6px)"
				borderRadius="16px"
				direction="column"
				alignItems="center"
				justifyContent="center"
				textAlign="center"
				p="24px">
				<Box
					position="relative"
					w="110px"
					h="110px"
					borderRadius="full"
					bg="linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)"
					boxShadow="0px 0 40px rgba(21, 168, 253, 1)">
					<Box overflow="hidden" p="23px">
						<LockedIcon fontSize="64px" />
						<Lines className="abstract-lines" style={{ zIndex: '1', top: '0%', transform: 'rotate(259deg) scale(0.2)', right: '0%', left: 'unset' }} />
					</Box>
				</Box>

				<Text variant="header" fontSize="24px" fontWeight="800 !important" mt="24px">
					Partner discounts are locked
				</Text>
				<Text variant="text-sm" fontWeight="500" color={textColor} mt="8px" maxW="420px">
					Partner discounts are not included in your Everyday Saver membership. Upgrade your membership to unlock all partners and their discounts.
				</Text>

				<Button
					as={NavLink}
					to="/account/membership"
					variant="button-md"
					h="48px"
					w="220px"
					borderRadius="full"
					mt="24px">
					Upgrade membership
				</Button>
			</Flex>
		</Box>
	);
};

export default LockedPartners;
